import React, { FC, memo } from "react";

import { ICodelist } from "@/data/codelists";
import { IFilterComponentProps, useOnChangeFilterHandler } from "@/infrastructure/Filter";

import { CodelistGenericSelect, ICodelistGenericSelectProps } from "../Codelists";

interface Props<T>
  extends IFilterComponentProps<T>,
    Omit<ICodelistGenericSelectProps, keyof IFilterComponentProps<T>> {}

export const CodelistFilter: FC<Props<ICodelist | null>> = memo(({ name, onChange, ...rest }) => {
  const handleChange = useOnChangeFilterHandler(name, onChange);
  return <CodelistGenericSelect name={name} onChange={handleChange} {...rest} />;
});

export const CodelistMultiFilter: FC<Props<ICodelist[]>> = memo(({ name, onChange, ...rest }) => {
  const handleChange = useOnChangeFilterHandler(name, onChange);
  return <CodelistGenericSelect name={name} onChange={handleChange} isMulti {...rest} />;
});
